<template>
    <div class="p-12 container">
        <div class="row">
            <div class="col-12">
                <h2>Dedicated Servers</h2>

                <ul class="breadcrumb bg-grey-100 rounded p-4 mb-8">
                    <li class="breadcrumb-item"><router-link to="/order">Order</router-link></li>
                    <li class="breadcrumb-item active">Dedicated Servers</li>
                </ul>


            </div>
        </div>
        <div class="flex flex-wrap -m-4" v-if="loading">
            <div class="w-full">

                <p>Choose a bundle that suites your needs, or customise and build your own.</p>

                <div class="text-center m-4">
                    <img src="/img/spinner.gif" />
                    <h6 class="sau-pm-reset">
                        Adding Server
                    </h6>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="flex flex-wrap -m-4 pb-8">
                <div v-for="(config, index) in configs" :key="index" class="w-full md:w-1/2 lg:w-1/3 items-stretch mb-12 lg:mb-0">
                    <div class="preconfig text-center sau-bx p-6 h-100 flex flex-col m-4">
                        <img :src="preconfigImage(index)" class="w-full" />

                        <h2>{{ config.package | CapitaliseFirst }}</h2>

                        <p>{{ config.description }}</p>

                        <hr>

                        <ul class="list-unstyled">
                            <li v-if="config.cpu">{{ config.cpu.description }}</li>
                            <li v-if="config.ram">{{ config.ram.description }}</li>
                            <li v-for="(drive, index) in config.storage" :key="index"><small class="text-muted">{{ storageSetLabel(index) }}: </small>
                            <br>{{ drive.description }}</li>
                        </ul>

                        <!-- <hr> -->

                        <button class="btn btn-success w-100 mt-auto" @click.prevent="addPreconfigDedi(config, false)">Buy Now</button>

                        <p><small>or <a href="#" @click.prevent="addPreconfigDedi(config, true)">customise this server</a></small></p>
                    </div>
                </div>
            </div>

            <!-- <lets-talk class="my-8"></lets-talk> -->
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LetsTalk from './partials/LetsTalk';

export default {
    props: {
        data: Object,
        order: Object,
    },

    components: {
        LetsTalk,
    },

    data() {
        return {
            configs: [],
            loading: false,
            addingAnItem: false,
            type: 'dedicated-server',
        }
    },

    mounted() {
        this.configs = this.data.config.products.preconfiguredDedis;
    },

    methods: {
        storageSetLabel(index) {
            switch(index) {
                case 0:
                    return 'Primary Disk';
                case 1:
                    return 'Secondary Disk';
                default:
                    return 'Additional Disk';
            }
        },

        addPreconfigDedi(config, custom) {
            if (this.addingAnItem) {
                return;
            }

            this.loading = true;
            this.addingAnItem = true;
            let itemData = {
                ...config.order,
                ...({ custom: custom }),
            };

            window.bus.$once('order.items.created', response => {
                this.addingAnItem = false;
                window.bus.$emit('order.items.update', this.type, response.data.slug, itemData);
            });

            window.bus.$once('order.items.updated', response => {
                this.loading = false;
                window.bus.$emit('order.items.edit', response.data.slug);
            });

            window.bus.$once('order.items.update-failed', error => {
                this.loading = false;
            });

            window.bus.$emit('order.items.create', this.type, itemData);
        },

        preconfigImage(index) {
            switch (index) {
                case 0:
                    return '/img/config-light.svg';
                case 1:
                    return '/img/config-essential.svg';
                case 2:
                    return '/img/config-performance.svg';
            }
        },

    },

}
</script>

<style lang="scss">
    .preconfig {
        img {
            max-width: 50%;
            display: block;
            margin: 0 auto;
        }
    }
</style>
